import { render, staticRenderFns } from "./discount.vue?vue&type=template&id=183e070a&scoped=true"
import script from "./discount.vue?vue&type=script&lang=js"
export * from "./discount.vue?vue&type=script&lang=js"
import style0 from "./discount.vue?vue&type=style&index=0&id=183e070a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183e070a",
  null
  
)

export default component.exports